export default __webpack_public_path__ + "static/media/fromthebeyond.454d3dd1.png";